// Protege los productos "oferta combo": solo se pueden comprar junto al producto principal
// y como máximo tantas unidades como el producto principal que haya en el carrito.
(function () {
  var REGLAS = [
    { combo: 48372338098374, padres: [9122050015430, 9127932035270] }, // Árbol Mágico combo ← Árbol de fieltro o Proyector navideño
    { combo: 48371587776710, padres: [9096315076806] }  // Capa combo ← Árbol Mágico
  ];
  var ruta = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var revisando = false, pendiente = null;
  var fetchOriginal = window.fetch.bind(window);
  function revisar() {
    if (revisando) return; revisando = true;
    fetchOriginal(ruta + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var cambios = [];
      REGLAS.forEach(function (rg) {
        var padre = 0; cart.items.forEach(function (it) { if (rg.padres.indexOf(it.product_id) !== -1) padre += it.quantity; });
        cart.items.forEach(function (it) { if (it.variant_id === rg.combo && it.quantity > padre) { cambios.push({ id: it.key, quantity: padre }); padre = 0; } });
      });
      if (!cambios.length) { revisando = false; return; }
      return cambios.reduce(function (p, c) {
        return p.then(function () { return fetchOriginal(ruta + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(c) }); });
      }, Promise.resolve()).then(function () { location.reload(); });
    }).catch(function () { revisando = false; });
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = fetchOriginal(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { clearTimeout(pendiente); pendiente = setTimeout(revisar, 400); });
    return p;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revisar); else revisar();
})();
